import type { YouTubePosition } from "@/lib/types";

const YOUTUBE_HOSTS = /(?:youtube\.com|youtu\.be|youtube-nocookie\.com)/i;
const VIDEO_ID = /^[\w-]{11}$/;

function sanitizeId(id: string | null | undefined): string | null {
  if (!id) return null;
  return VIDEO_ID.test(id) ? id : null;
}

export function parseYouTubeVideoId(url: string): string | null {
  const trimmed = url.trim();
  if (!trimmed) return null;
  try {
    const u = new URL(trimmed);
    if (!YOUTUBE_HOSTS.test(u.hostname)) return null;

    if (u.hostname.includes("youtu.be")) {
      return sanitizeId(u.pathname.slice(1).split("/")[0]);
    }
    if (u.pathname.startsWith("/embed/")) {
      return sanitizeId(u.pathname.split("/")[2]);
    }
    if (u.pathname.startsWith("/shorts/")) {
      return sanitizeId(u.pathname.split("/")[2]);
    }
    return sanitizeId(u.searchParams.get("v"));
  } catch {
    return null;
  }
}

export function isValidYouTubeUrl(url: string): boolean {
  return parseYouTubeVideoId(url) !== null;
}

export function toYouTubeEmbedUrl(videoId: string): string {
  return `https://www.youtube.com/embed/${videoId}`;
}

export function normalizeYouTubePosition(position: string | null | undefined): YouTubePosition {
  return position === "bottom" ? "bottom" : "top";
}
